import { render, staticRenderFns } from "./UnsupportedBrowserPage.vue?vue&type=template&id=63b4d997&"
import script from "./UnsupportedBrowserPage.vue?vue&type=script&lang=js&"
export * from "./UnsupportedBrowserPage.vue?vue&type=script&lang=js&"
import style0 from "./UnsupportedBrowserPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports